import { AmateurProgramsLandingQuery } from '@layouts/amateur-programs-landing'

const AmateurProgramsLandingPage = (props) => {
  return <AmateurProgramsLandingQuery {...props} />
}

AmateurProgramsLandingPage.getInitialProps = async ({ query }) => {
  return ({ query })
}

export default AmateurProgramsLandingPage
